import type { Dish } from "@arfood/shared";
import { actionButton, allergenChips, el, formatPrice, pickI18n } from "./util.ts";

// T0 — 2D-Fallback. Gleiche Daten wie T1, ohne 3D/AR.
export function createDishCardT0(dish: Dish, lang: string): HTMLElement {
  const { name, desc } = pickI18n(dish, lang);

  const card = el("article", "dish-card dish-card--t0");
  card.dataset["tier"] = "T0";
  card.dataset["dish"] = dish.id;

  const wrap = el("div", "dish-media-wrap");
  if (dish.model.poster) {
    const img = document.createElement("img");
    img.className = "dish-media";
    img.src = dish.model.poster;
    img.alt = name;
    img.loading = "lazy";
    wrap.appendChild(img);
    wrap.appendChild(mediaBadge("Foto"));
  } else {
    wrap.classList.add("dish-media--placeholder");
    wrap.setAttribute("role", "img");
    wrap.setAttribute("aria-label", name);
  }

  const order = actionButton("btn-primary", "order", "+ Hinzufügen");
  card.append(wrap, buildBody(name, desc, dish, lang, [order]));
  return card;
}

function mediaBadge(text: string): HTMLElement {
  const b = el("span", "badge-media");
  b.textContent = text;
  return b;
}

// Karten-Rumpf: Kopf (Name + Preis), Beschreibung + „Mehr", Allergen-Chips, Aktionen.
// „Mehr" bleibt separates Element (nicht im .dish-desc), damit relabel() (textContent) es nicht löscht.
export function buildBody(name: string, desc: string, dish: Dish, lang: string, actions: HTMLElement[]): HTMLElement {
  const body = el("div", "dish-body");

  const head = el("div", "dish-head");
  const h = el("h2", "dish-name");
  h.textContent = name;
  const price = el("span", "dish-price");
  price.textContent = formatPrice(dish.priceCents);
  head.append(h, price);
  body.appendChild(head);

  if (desc) {
    const p = el("p", "dish-desc clamp");
    p.textContent = desc;
    body.appendChild(p);
    body.appendChild(actionButton("link-btn", "details", "Mehr"));
  }

  const chips = allergenChips(dish.allergens, lang);
  if (chips) body.appendChild(chips);

  const act = el("div", "dish-actions");
  act.append(...actions);
  body.appendChild(act);

  return body;
}
